'use client';

import { useEffect } from 'react';
import { FACTORING_PAGE_PATH } from '../../../../pages';
import { useFinancialProductsConfig } from '@ui/shared/FinancialProductsProvider/FinancialProductsProvider';
import FactoringUpsellEntryPointProvider, {
  FactoringUpsellEntryPoint,
  useFactoringUpsellEntryPointImpression,
} from '../../(marketplace)/_ui/FactoringUpsell/FactoringUpsellEntryPointProvider';
import NavLink from '~/app/(authenticated)/_ui/NavItems/NavLink';
import DallasSvgIconFactoringOriginalOutlined from '@ui/Dallas/Icons/DallasSvgIconFactoringOriginalOutlined';
import useIsActivePathname from '~/app/(authenticated)/_lib/useIsActivePath';
import useTrackAnalyticsEventFactoringUpsell from '@lib/analytics/useTrackAnalyticsEventFactoringUpsell';

export default function FactoringNavLink() {
  return (
    <FactoringUpsellEntryPointProvider
      value={FactoringUpsellEntryPoint.NavbarLinkBadge}
      shouldHideIfEngagementRecorded={false}
    >
      <FactoringNavLinkImpl />
    </FactoringUpsellEntryPointProvider>
  );
}

function FactoringNavLinkImpl() {
  const isActive = useIsActivePathname(FACTORING_PAGE_PATH);
  const {
    factoring: { carrierActiveForFactoring },
  } = useFinancialProductsConfig();
  const { data, accept, bumpViewCount } =
    useFactoringUpsellEntryPointImpression();
  const track = useTrackAnalyticsEventFactoringUpsell();
  const shouldShowBrandBadge = !carrierActiveForFactoring && !data?.hasAccepted;

  useEffect(() => {
    if (shouldShowBrandBadge) {
      bumpViewCount();
    }
  }, [shouldShowBrandBadge, bumpViewCount]);

  return (
    <NavLink
      href={FACTORING_PAGE_PATH}
      label="Factoring"
      icon={<DallasSvgIconFactoringOriginalOutlined />}
      active={isActive}
      withBrandBadge={shouldShowBrandBadge}
      onClick={() => {
        accept();
        track({
          type: 'FACTORING_UPSELL_ENGAGEMENT',
          metadata: {
            action: 'accept',
          },
        });
      }}
    />
  );
}
